import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AiChatComponent } from './ai-chat.component';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [AiChatComponent],
  imports: [CommonModule, ReactiveFormsModule, MarkdownModule.forChild()],
  exports: [AiChatComponent],
})
export class AiChatModule {}
